import { render, staticRenderFns } from "./BaseDragAndDrop.vue?vue&type=template&id=694efe6a&scoped=true"
import script from "./BaseDragAndDrop.vue?vue&type=script&lang=js"
export * from "./BaseDragAndDrop.vue?vue&type=script&lang=js"
import style0 from "./BaseDragAndDrop.vue?vue&type=style&index=0&id=694efe6a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "694efe6a",
  null
  
)

export default component.exports